// eslint-disable-next-line import/prefer-default-export
export const WAVE_1_PRICE = "0.3 SOL";
export const WAVE_2_PRICE = "0.9 SOL";
